import {
  type AlbumsQueryModelWithPagination,
  albumCreate,
  albumDelete,
  albumUpdate,
  createAlbumsQueryModel,
} from '@/entities/albums'
import { createModalModel } from '@/shared/lib/model-factories'
import { createEvent, createStore } from 'effector'
import { sample } from 'effector'
import { createGate } from 'effector-react'

export const AlbumsSelectionTableGate = createGate()

export const AlbumsSelectionTableAlbumsQueryModel = createAlbumsQueryModel({
  usePagination: true,
  accumulate: false,
}) as AlbumsQueryModelWithPagination
const { availableSet, unavailableSet } = AlbumsSelectionTableAlbumsQueryModel
export const {
  //   Query
  query: albumsSelectionTableQuery,
  //   Init
  filtersInit: albumsSelectionTableFiltersInit,
  //   Search
  $search: $albumsSelectionTableSearch,
  searchChanged: albumsSelectionTableSearchChanged,
  searchReset: albumsSelectionTableSearchReset,
  //   Sort
  $sort: $albumsSelectionTableSort,
  sortChanged: albumsSelectionTableSortChanged,
  sortReset: albumsSelectionTableSortReset,
  //   Pagination
  $page: $albumsSelectionTablePage,
  pageChanged: albumsSelectionTablePageChanged,
  pageReset: albumsSelectionTablePageReset,
  $pageSize: $albumsSelectionTablePageSize,
  //   Refresh
  refreshed: albumsSelectionTableRefreshed,
} = AlbumsSelectionTableAlbumsQueryModel

export const $albumsSelectionTableSearchInputValue = createStore('')
  .on(albumsSelectionTableSearchChanged, (_, q) => q)
  .reset(albumsSelectionTableSearchReset)

sample({
  clock: AlbumsSelectionTableGate.open,
  target: availableSet,
})

sample({
  clock: AlbumsSelectionTableGate.close,
  target: unavailableSet,
})

sample({
  clock: [
    albumCreate.finished.success,
    albumUpdate.finished.success,
    albumDelete.finished.success,
  ],
  target: albumsSelectionTableRefreshed,
})

// Selection
export const albumSelectionReset = createEvent()
export const albumIdSelected = createEvent<string>()
export const $selectedAlbumId = createStore<string | null>(null)
  .on(albumIdSelected, (state, id) => (state === id ? null : id))
  .on(albumSelectionReset, () => null)

// Selection Modal
export const {
  modalOpened: albumSelectionModalOpened,
  modalClosed: albumSelectionModalClosed,
  $isModalOpened: $isAlbumSelectionModalOpen,
} = createModalModel()
